const PRODUCTS = [
  { label: 'Speech Rec.', color: '#1ec8ff' },
  { label: 'Voice Cloning', color: '#ff5aa0' },
  { label: 'Dubbing', color: '#ffaa3a' },
  { label: 'Translation', color: '#39e0a0' },
  { label: 'Emotion', color: '#ff6a3a' },
  { label: 'Speaker ID', color: '#9b7bff' },
  { label: 'Denoising', color: '#3affe0' },
  { label: 'Music Gen', color: '#ff7bd8' },
  { label: 'Accessibility', color: '#88ffaa' },
  { label: 'Call Centers', color: '#ffd23a' },
  { label: 'Education', color: '#4aa8ff' },
  { label: 'Search', color: '#c0a0ff' },
]

const CX = 160, CY = 200, R = 130
const NODES = PRODUCTS.map((p, i) => {
  const angle = (i / PRODUCTS.length) * Math.PI * 2 - Math.PI / 2
  return { ...p, x: CX + Math.cos(angle) * R, y: CY + Math.sin(angle) * R }
})

// One Voice-AI core branching into a constellation of products — the whole
// ring slowly rotates while node labels stay upright, same idea as the
// desktop fibonacci-sphere layout flattened to 2D.
export function Scene12Universe2D() {
  return (
    <svg viewBox="-20 0 360 400" style={{ width: '100%', maxWidth: 340, height: 'auto', display: 'block', margin: '0 auto' }}>
      <style>{`
        @keyframes universeSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes universeCounterSpin { from { transform: rotate(0deg); } to { transform: rotate(-360deg); } }
        @keyframes nodePulse { 0%, 100% { transform: scale(0.9); } 50% { transform: scale(1.1); } }
      `}</style>
      <g style={{ transformOrigin: `${CX}px ${CY}px`, animation: 'universeSpin 40s linear infinite' }}>
        {NODES.map((n) => (
          <line key={n.label} x1={CX} y1={CY} x2={n.x} y2={n.y} stroke="#3a5a7a" strokeWidth="1" opacity="0.3" />
        ))}
        {NODES.map((n, i) => (
          <g key={n.label} style={{ transformOrigin: `${n.x}px ${n.y}px`, animation: `nodePulse ${1.8 + (i % 3) * 0.3}s ease-in-out infinite` }}>
            <circle cx={n.x} cy={n.y} r="9" fill={n.color} />
          </g>
        ))}
        {/* counter-rotating labels so text stays upright while the ring spins */}
        {NODES.map((n) => (
          <g key={`${n.label}-label`} style={{ transformOrigin: `${n.x}px ${n.y}px`, animation: 'universeCounterSpin 40s linear infinite' }}>
            <text x={n.x} y={n.y - 16} fill={n.color} fontSize="9" fontFamily="system-ui, sans-serif" textAnchor="middle">{n.label}</text>
          </g>
        ))}
      </g>

      <circle cx={CX} cy={CY} r="20" fill="#eaf4ff" />
      <text x={CX} y={CY + 38} fill="#ffffff" fontSize="13" fontFamily="system-ui, sans-serif" textAnchor="middle" fontWeight="700">Voice AI</text>
    </svg>
  )
}
